import { createTheme } from "../utils/create-theme";
export var LAB_THEME = createTheme('lab', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#7674C0',
      secondary: '#D2B400',
      primaryDarker: '#474673',
      primaryLight: '#928ECD',
      primaryLighter: '#BCB7DF',
      primaryBright: '#7674C0',
      primaryVeryLight: '#D9D4EC',
      link: '#7674C0',
      linkHover: '#000000',
      navigationActive: '#D2B400',
      accentDark: '#474673',
      accentLight: '#928ECD'
    }
  },
  dark: {
    color: {
      linkHover: '#7674C0'
    }
  }
});
export default LAB_THEME;